import { FaRegCopy } from "react-icons/fa";
import { FaLink } from "react-icons/fa6";
import { FaKey } from "react-icons/fa";
import { FaRegCheckSquare } from "react-icons/fa";
import { IoCloseCircleSharp } from "react-icons/io5";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useGetDownloadLink } from "../hooks/Muitation/useGetDownloadLink";
import Loader from "../assets/images/fidelityLoader.gif";
export const DownloadModal = ({ openModal, setOpenModal, value, payload }) => {
  const [downloadData, setDownloadData] = useState();
  const [isFetching, setIsFetching] = useState();

  console.log("downloadData", downloadData);

  const { mutate: getDownloadLink } = useGetDownloadLink();

  const activeReport = useSelector(
    (state) => state?.dashboardActivePage?.activeReport
  );
  console.log("activeReport", activeReport)



  useEffect(() => {
    if (!openModal) return;

    if (!value) {
      toast.error("Kindly fill all required fields.");
      setOpenModal(false);
      return;
    }

    setIsFetching(true);

    getDownloadLink(
      { payload, menu_id: activeReport },
      {
        onSuccess: (res) => {
          setTimeout(() => {
            setDownloadData(res?.data?.data);
            setIsFetching(false);
          }, 1500);
        },
        onError: (err) => {
          console.log(err);
          toast.error("An error occurred");
          setIsFetching(false);
          setOpenModal(false);
        },
      }
    );
  }, [openModal,]);

  const truncateString = (str, len) => {
    if (str.length > len) {
      return str?.slice(0, len) + "...";
    } else {
      return str;
    }
  };
  const downloadKey = "data?.dashboard-key";

  // HANDLE COPY LINK
  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Text copied!");
    } catch (err) {
      toast.error("Failed to copy:", err);
    }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50  flex justify-center items-center ">
      <div className="fixed bg-white md:w-[30rem] rounded-md px-8 py-4">
        {isFetching ? (
          <div>
            <div className="flex justify-center items-center">
              <img src={Loader} alt="loader" />
            </div>
            <p>We are preparing your dashboard link, please wait ....</p>
          </div>
        ) : (
          <>
            <button
              variant="default"
              className="w-full flex justify-end mt-[-10px] cursor-pointer"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              <IoCloseCircleSharp size={25} />
            </button>
            <div className="text-lg font-semibold text-center mb-2">
              Your Download is Ready!
            </div>
            <p className="text-sm mb-4 text-center">
              Below is your secure download link and access key. Please copy and
              use them to retrieve your file
            </p>
            <div className="mb-4">
              <div className="flex items-center gap-1 font-bold">
                <FaLink />
                <p className="p-0 m-0 text-sm font-bold">Download Link</p>
              </div>
              <div className="w-full h-10 bg-white rounded-md border border-1 border-grey-100 shadow-md p-2">
                <div className="flex justify-between items-center">
                  {downloadData?.downloadLink &&
                    truncateString(downloadData?.downloadLink, 30)}
                  {/* {truncateString(downloadData?.downloadLink, 30)} */}

                  <FaRegCopy
                    size={20}
                    className="cursor-pointer"
                    onClick={() => handleCopy(downloadData?.downloadLink)}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <div className="flex items-center gap-1 font-bold">
                <FaKey />
                <p className="p-0 m-0 text-sm font-bold">Download Key</p>
              </div>
              <div className="w-full h-10 bg-white rounded-md border border-1 border-grey-100 shadow-md p-2">
                <div className="flex justify-between items-center">
                  {downloadKey}

                  <FaRegCopy
                    size={20}
                    className="cursor-pointer"
                    onClick={() => handleCopy(downloadKey)}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className="flex items-center gap-1 font-bold">
                <FaRegCheckSquare className="" />
                <p className="p-0 m-0 text-sm font-bold">Instructions</p>
              </div>
              <ul className="list-disc pl-5 text-[15px]">
                <li className="mb-1">Copy the link and key above</li>
                <li className="mb-1">
                  Paste them into the appropriate field or share with authorized
                  personnel.
                </li>
                <li className="mb-1">
                  The link may expire after 24 hours for security reasons.
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
